<div class="modal-container">
  <h2>Do you live in a Rural Area?</h2>
  <mat-radio-group [(ngModel)]="selectedOption">
    <mat-radio-button (click)="selectedOption = 'isRural'; confirmSelection()" value="isRural">Yes</mat-radio-button>
    <mat-radio-button (click)="selectedOption = 'urban'; confirmSelection()" value="urban">No</mat-radio-button>
  </mat-radio-group>
</div>
